import * as React from "react";

import { Deedle } from "components";

interface PropsType {
  caseNumber: string;
  trusteeName: string;
}

const displayText = (text = ""): string => (text.length ? text : "Unassigned");

export default function CaseInfo(props: PropsType): JSX.Element {
  const { caseNumber, trusteeName } = props;

  return (
    <section data-test-id="caseInfo">
      <h2>Case Info</h2>
      <Deedle term="Case Number" definition={displayText(caseNumber)} />
      <Deedle term="Trustee" definition={displayText(trusteeName)} />
    </section>
  );
}
